import { render, staticRenderFns } from "./ModalPackageQuantity.vue?vue&type=template&id=b2d21f64&scoped=true&lang=pug"
import script from "./ModalPackageQuantity.vue?vue&type=script&lang=js"
export * from "./ModalPackageQuantity.vue?vue&type=script&lang=js"
import style0 from "./ModalPackageQuantity.vue?vue&type=style&index=0&id=b2d21f64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d21f64",
  null
  
)

export default component.exports